import React from 'react';
import { useLocation } from 'react-router-dom';
import AppHeader from './AppHeader';
import { useShowcaseMode } from '../hooks/useShowcaseMode';

const RESERVED_FIRST_SEGMENTS = new Set([
  'login',
  'register',
  'admin',
  'garage',
  'events',
  'organizer',
  'judge',
  'invite',
  'static',
  'api',
  'v',
  'discover',
  'clubs',
  'badges',
  'favorites',
  'shops',
  'search',
  'settings',
]);

/**
 * Hides global nav on vehicle profile pages (canonical /:user/:slug and legacy /v/...)
 * and iPad showcase/kiosk views — matches the premium share chrome. Owners use
 * sidebar Owner tools for actions. VehiclePage sticky header provides back/home + brand.
 */
const ConditionalAppHeader: React.FC = () => {
  const location = useLocation();
  const isShowcaseMode = useShowcaseMode();

  const segments = location.pathname.split('/').filter(Boolean);
  const isLegacyV = segments[0] === 'v' && segments.length >= 3;
  const isBareVehicle =
    segments.length === 2 && !RESERVED_FIRST_SEGMENTS.has(segments[0].toLowerCase());
  const isVehiclePage = isLegacyV || isBareVehicle;

  if (isVehiclePage || isShowcaseMode) {
    return null;
  }

  return <AppHeader />;
};

export default ConditionalAppHeader;
